import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Badge, Card, Col, Row } from 'react-bootstrap';
import CountUp from 'react-countup';
import HalfDoughnutChart from './../HalfDoughnutChart';

import { useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';

const AvanceVentasItemsMes = (
    {
        mes,
        idUsuario
    }
) => {

    const [cargando, setCargando] = useState(true);
    const { token, setToken } = useToken();
    const { showErrorToast } = useToast();
    const [ventasMes, setVentasMes] = useState({});
    const [variablesMetasControl, setVariablesMetasControl] = useState({});

    const ObtenerItemsVendidosMes = async (date_, idUsuario) => {
        console.log("date_: ", date_);
        setCargando(true);
        const response = await fetch("/api/home/ObtenerItemsVendidosMes?idUsuario=" + idUsuario + "&date=" + date_, {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch: ' + error);
                console.log('Hubo un problema con la peticion Fetch: ' + error.message);

            });

        if (response.ok) {
            console.log(response);
            const data = await response.json();
            console.log(data);

            if (data['table1'][0].iResponseType == 1) {

                //Items del Mes
                setVentasMes(data['table2'][0]);
                setVariablesMetasControl(data['table3'][0])
            }
            else {
                showErrorToast(data['table1'][0].vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);

            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setCargando(false);

    };

    useEffect(() => {
        ObtenerItemsVendidosMes(mes, idUsuario)
    }, [idUsuario, mes])


    return (
        <Card className="h-md-100">
            <Card.Header className="pb-0">
                <Row>
                    <Col>
                        <h5 className="mb-0"> <img src="/img/analitycs48.png"></img>Your Monthly Items</h5>
                    </Col>

                </Row>

            </Card.Header>
            <Card.Body className="pt-0">

                <Row className="align-items-top">
                    {/*{cargando && <h3><Spinner className="text-inline" animation="border" variant="primary" /> Cargando...</h3>}*/}

                    {true &&
                        <>
                            <Col className="col-12 mt-3">


                                <Row className="g-0">
                                    <Col xs={6} sm={4} md={3} xl={3} xxl={2} className="align-items-center text-center border-300 border-end mb-3" >
                                        <h6 className="pb-0 text-700">
                                            LIC-SERV
                                        </h6>
                                        <span className={
                                            'font-sans-serif fs-2 ' + (ventasMes.iLicServ > 0 ? 'text-success' : 'text-danger')
                                        }>
                                            {cargando ? <Skeleton className="w-75" /> : ventasMes.iLicServ}
                                        </span>
                                        <div>
                                            <h6 className="fs--1 text-500 mb-0 ">

                                                {cargando ? <Skeleton className="w-75" /> :
                                                    <span>
                                                        ${parseFloat(ventasMes.dLicServSubtotal).toLocaleString("es-MX", {
                                                            maximumFractionDigits: 2,
                                                            minimumFractionDigits: 2
                                                        })}
                                                    </span>
                                                }



                                            </h6>
                                        </div>
                                    </Col>
                                    <Col xs={6} sm={4} md={3} xl={3} xxl={2} className="align-items-center text-center border-300 border-end" >
                                        <h6 className="pb-0 text-700">
                                            LIC-CAJ
                                        </h6>
                                        <span className={
                                            'font-sans-serif fs-2 ' + (ventasMes.iLicCaj > 0 ? 'text-success' : 'text-danger')
                                        }>
                                            {cargando ? <Skeleton className="w-75" /> : ventasMes.iLicCaj}
                                        </span>
                                        <div>
                                            <h6 className="fs--1 text-500 mb-0 ">
                                                {cargando ? <Skeleton className="w-75" /> :
                                                    <span>
                                                        ${parseFloat(ventasMes.dLicCajSubtotal).toLocaleString("es-MX", {
                                                            maximumFractionDigits: 2,
                                                            minimumFractionDigits: 2
                                                        })}
                                                    </span>
                                                }
                                            </h6>
                                        </div>
                                    </Col>
                                    <Col xs={6} sm={4} md={3} xl={3} xxl={2} className="align-items-center text-center border-300 border-end" >
                                        <h6 className="pb-0 text-700">
                                            P&Oacute;LIZAS
                                        </h6>
                                        <span className={
                                            'font-sans-serif fs-2 ' + (ventasMes.iPoliza > 0 ? 'text-success' : 'text-danger')
                                        }>
                                            {cargando ? <Skeleton className="w-75" /> : ventasMes.iPoliza}
                                        </span>
                                        <div>
                                            <h6 className="fs--1 text-500 mb-0 ">
                                                {cargando ? <Skeleton className="w-75" /> :
                                                    <span>
                                                        ${parseFloat(ventasMes.dPolizaSubtotal).toLocaleString("es-MX", {
                                                            maximumFractionDigits: 2,
                                                            minimumFractionDigits: 2
                                                        })}
                                                    </span>
                                                }
                                            </h6>
                                        </div>
                                    </Col>

                                    <Col xs={6} sm={4} md={3} xl={3} xxl={2} className="align-items-center text-center border-300 border-end" >
                                        <h6 className="pb-0 text-700">
                                            LIC-NUB
                                        </h6>
                                        <span className={
                                            'font-sans-serif fs-2 ' + (ventasMes.iLicNub > 0 ? 'text-success' : 'text-danger')
                                        }>
                                            {cargando ? <Skeleton className="w-75" /> : ventasMes.iLicNub}
                                        </span>
                                        <div>
                                            <h6 className="fs--1 text-500 mb-0 ">
                                                {cargando ? <Skeleton className="w-75" /> :
                                                    <span>
                                                        ${parseFloat(ventasMes.dLicNubSubtotal).toLocaleString("es-MX", {
                                                            maximumFractionDigits: 2,
                                                            minimumFractionDigits: 2
                                                        })}
                                                    </span>
                                                }
                                            </h6>
                                        </div>
                                    </Col>
                                    <Col xs={6} sm={4} md={3} xl={3} xxl={2} className="align-items-center text-center border-300 border-end" >
                                        <h6 className="pb-0 text-700">
                                            LIC-NUB-R
                                        </h6>
                                        <span className={
                                            'font-sans-serif fs-2 ' + (ventasMes.iLicNubRenov > 0 ? 'text-success' : 'text-danger')
                                        }>
                                            {cargando ? <Skeleton className="w-75" /> : ventasMes.iLicNubRenov}
                                        </span>
                                        <div>
                                            <h6 className="fs--1 text-500 mb-0 ">
                                                {cargando ? <Skeleton className="w-75" /> :
                                                    <span>
                                                        ${parseFloat(ventasMes.dLicNubRenovSubtotal).toLocaleString("es-MX", {
                                                            maximumFractionDigits: 2,
                                                            minimumFractionDigits: 2
                                                        })}
                                                    </span>
                                                }
                                            </h6>
                                        </div>
                                    </Col>

                                </Row>
                                <hr />

                            </Col>
                            <Col xs={7} className="pe-md-0">

                                <Row className="mt-3 mb-4 flex-between-center">
                                    <Col xs={12} sm={12} >

                                        {/*<h5 className="text-800 fs-2">${parseFloat(ventas.nItemsVendidosMes).toLocaleString("es-MX", {
                                            maximumFractionDigits: 2,
                                            minimumFractionDigits: 2
                                        })} MXN</h5>*/}

                                        {cargando ?
                                            (<h5><Skeleton /></h5>)
                                            :
                                            <h5 className='font-sans-serif fs-2 mb-md-0 mb-lg-2 text-dark'>

                                            </h5>
                                        }

                                        {cargando ?
                                            (<h5><Skeleton /></h5>)
                                            :
                                            (<h5 className={
                                                'font-sans-serif fs-2 mb-md-0 mb-lg-2 ' + (variablesMetasControl.nItemsVendidosMes > 0 ? 'text-success' : 'text-danger')
                                            } >{variablesMetasControl.nItemsVendidosMes} Items</h5>)
                                        }


                                    </Col>
                                </Row>
                                <Row className="g-0 align-items-center">
                                    <Col xs={4}>
                                        <h5 className="mb-0 text-600">
                                            {
                                                cargando ?
                                                    <Skeleton className="w-50" />
                                                    :
                                                    "Target:"
                                            }
                                        </h5>
                                    </Col>
                                    <Col xs={8}>
                                        {/*<h6 className="mb-0 text-800">${parseFloat(ventas.dMetaMensualItems).toLocaleString("es-MX", {
                                            maximumFractionDigits: 2,
                                            minimumFractionDigits: 2
                                        })} MXN</h6>*/}

                                        {
                                            cargando ?
                                                <h5 className="mb-0 text-800"><Skeleton /></h5>
                                                :
                                                <>
                                                    <h5 className="mb-0 text-800"><Badge bg="info" pill>{variablesMetasControl.dMetaMensualItems} items</Badge></h5>
                                                </>
                                        }

                                    </Col>
                                </Row>

                            </Col>
                            <Col xs={5}>

                                <div
                                    className="ms-auto text-center"
                                    style={{ maxWidth: '10.625rem' }}
                                >
                                    {cargando ?
                                        <div>

                                            <Skeleton circle width={100} height={100} className="mb-1" />
                                            <Skeleton className="w-50" />

                                        </div>

                                        :
                                        (
                                            <div>

                                                <div className="mb-n6">
                                                    <HalfDoughnutChart
                                                        color="primary"
                                                        target={variablesMetasControl.dMetaMensualItems}
                                                        reached={variablesMetasControl.nItemsVendidosMes}
                                                    />
                                                </div>
                                                <CountUp
                                                    start={0}
                                                    end={((variablesMetasControl.nItemsVendidosMes / variablesMetasControl.dMetaMensualItems) * 100).toFixed(0)}
                                                    duration={2.75}
                                                    className="d-inline-block mb-0 mt-n6 fs-1 fw-medium font-sans-serif"
                                                    suffix="%"
                                                    separator=","
                                                />

                                            </div>

                                        )
                                    }
                                </div>


                            </Col>


                        </>
                    }
                </Row>
            </Card.Body>
        </Card>
    );
};

//const [dateQuarter, setDateQuarter] = useState(new Date())


AvanceVentasItemsMes.propTypes = {
    idUsuario: PropTypes.number,
    mes: PropTypes.instanceOf(Date)
};
export default AvanceVentasItemsMes;
